import { render, staticRenderFns } from "./uploadAlert.vue?vue&type=template&id=4e6ba01c&lang=html"
import script from "./uploadAlert.vue?vue&type=script&lang=js"
export * from "./uploadAlert.vue?vue&type=script&lang=js"
import style0 from "./uploadAlert.vue?vue&type=style&index=0&id=4e6ba01c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports